var map = {
	"./Agoda.png": 67315,
	"./TRIPADVISOR_EN.png": 2306,
	"./article.png": 9851,
	"./articleBgC.png": 3723,
	"./articleDefault.png": 60380,
	"./book.png": 97118,
	"./booking.png": 96376,
	"./comment.png": 35390,
	"./comment/ai.png": 63169,
	"./comment/competitor.png": 83261,
	"./comment/competitor_a.png": 58837,
	"./comment/ins_1.png": 89571,
	"./comment/ins_2.png": 27592,
	"./comment/ins_3.png": 75985,
	"./comment/ins_4.png": 31422,
	"./comment/ins_5.png": 7207,
	"./comment/ins_6.png": 40172,
	"./comment/my.png": 40245,
	"./comment/my_a.png": 24189,
	"./comment/scatter.png": 83793,
	"./comment/scatter2.png": 60631,
	"./comment/scatter2_active.png": 35442,
	"./comment/scatter_active.png": 6060,
	"./dalong.png": 53110,
	"./delete.png": 40988,
	"./dianping.png": 87213,
	"./douyin.png": 48609,
	"./down.png": 3109,
	"./download.png": 4069,
	"./edit_primary.png": 22162,
	"./edit_white.png": 37431,
	"./elong.png": 51866,
	"./empty.png": 43358,
	"./expedia.png": 74949,
	"./feizhu.png": 36034,
	"./gaode.png": 43815,
	"./google.png": 8472,
	"./heart.png": 61513,
	"./home-icons/1.png": 55601,
	"./home-icons/10.png": 4261,
	"./home-icons/11.png": 21372,
	"./home-icons/12.png": 79479,
	"./home-icons/13.png": 33902,
	"./home-icons/14.png": 51617,
	"./home-icons/15.png": 30488,
	"./home-icons/16.png": 76243,
	"./home-icons/17.png": 37386,
	"./home-icons/18.png": 13981,
	"./home-icons/19.png": 80948,
	"./home-icons/2.png": 47290,
	"./home-icons/20.png": 49248,
	"./home-icons/21.png": 4073,
	"./home-icons/3.png": 52515,
	"./home-icons/4.png": 22348,
	"./home-icons/5.png": 5237,
	"./home-icons/6.png": 19486,
	"./home-icons/7.png": 90823,
	"./home-icons/8.png": 63552,
	"./home-icons/9.png": 18377,
	"./home-mobile-icons/1.png": 75328,
	"./home-mobile-icons/10.png": 20578,
	"./home-mobile-icons/11.png": 41707,
	"./home-mobile-icons/12.png": 71856,
	"./home-mobile-icons/13.png": 68761,
	"./home-mobile-icons/14.png": 75686,
	"./home-mobile-icons/15.png": 14703,
	"./home-mobile-icons/16.png": 95796,
	"./home-mobile-icons/17.png": 16925,
	"./home-mobile-icons/18.png": 82858,
	"./home-mobile-icons/19.png": 21715,
	"./home-mobile-icons/2.png": 53659,
	"./home-mobile-icons/20.png": 17939,
	"./home-mobile-icons/21.png": 67178,
	"./home-mobile-icons/3.png": 55794,
	"./home-mobile-icons/4.png": 11949,
	"./home-mobile-icons/5.png": 72004,
	"./home-mobile-icons/6.png": 26655,
	"./home-mobile-icons/7.png": 30326,
	"./home-mobile-icons/8.png": 58609,
	"./home-mobile-icons/9.png": 44392,
	"./home-welcome.png": 58679,
	"./hotel.png": 90223,
	"./icon-back.png": 26772,
	"./icon-edit.png": 89437,
	"./icon-medal.png": 74156,
	"./icon-message.png": 80284,
	"./icon-phone.png": 55073,
	"./icon-workflow.png": 43822,
	"./info-white.png": 33689,
	"./info.png": 4541,
	"./info_grey.png": 76787,
	"./jinjiang.png": 20609,
	"./kaiyuan.png": 99171,
	"./meituan.png": 96670,
	"./member.png": 9327,
	"./no-data.png": 55375,
	"./points-down.png": 30175,
	"./qrcodeQms.png": 40114,
	"./qunaer.png": 94705,
	"./rect.png": 75219,
	"./rujia.png": 46792,
	"./scroll_left.png": 64052,
	"./scroll_right.png": 62961,
	"./service_qrcode.png": 17363,
	"./shangmei.png": 45755,
	"./success.png": 63884,
	"./tripadvisor.png": 18558,
	"./up.png": 73870,
	"./vocust.png": 28849,
	"./wanda.png": 11618,
	"./warn-up.png": 78947,
	"./warning.png": 37697,
	"./whiteBg.png": 51563,
	"./xiecheng.png": 52104,
	"./xiechengappeal.png": 99765,
	"./xiechengappealh5.png": 46339,
	"./yasite.png": 77394,
	"./yifei.png": 72679,
	"./yifen.png": 93064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9294;